/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

import { makeStyles, TextField } from '@material-ui/core';

// import schemaValidate from  '../../services/schemaValidate';// '../../services/schemaValidate';
// import Autocomplete from "@material-ui/lab/Autocomplete";
// import TextInput from '../TextInput';
import schemaValidate from '../schemaValidate';  //'../../services/schemaValidate';// '../../services/schemaValidate';

const useTextFieldInputStyles = makeStyles(() => ({
        input: {
                "&&&:before": {
                        borderBottom: noBorder => noBorder ? "none" : ""
                },
                "&&:after": {
                        borderBottom: noBorder => noBorder ? "none" : ""
                }
        }
}));

const TextFieldInput = ({
        properties,
        field,
        label,
        fieldId,
        optionLabel,
        defaultValue,
        optionsList,
        params,
        inputClassName,
        inputValue,
        onChangeHandler,
        resetValueOnChange,
        disabled,
        type,
        textAlign,
        readOnly,
        multiline,
        rows,
        noBorder,
        textInputClass,
        standardvariant,
        helperText,
        endAdornment,
        onBlurHandler = () => { },
        ...rest
}) => {
        const { errors, control, schema } = properties;
        const classes = useTextFieldInputStyles(noBorder);
        // console.log(field);
        // const defVal = useMemo(() => !fieldId ? defaultValue : optionsList.find(opt => opt[fieldId] === defaultValue), [defaultValue, fieldId, optionsList]);   

        return (<>
                <Controller
                        control={control}
                        // name="item"
                        // rules={{ required: true }}
                        defaultValue={defaultValue || ''}
                        rules={{
                                validate: value => {
                                        return schemaValidate(value, field, schema, params);
                                }
                        }}
                        name={field}
                        render={({ field: { onChange, value, onBlur, ref } }) => (
                                <TextField
                                        variant={noBorder || standardvariant ? "standard" : "outlined"}
                                        value={value}
                                        onChange={onChange}
                                        onBlur={(e) => {
                                                onBlurHandler(e);
                                                onBlur(e);
                                        }}
                                        inputRef={ref}
                                        hiddenLabel={true}
                                        type={type}
                                        margin="dense"
                                        InputProps={{
                                                className: clsx("textfield-input-white", (noBorder ? "Mui-disabled text-dark" : ""), inputClassName),
                                                endAdornment: endAdornment,
                                                classes
                                        }}
                                        inputProps={{ readOnly: readOnly, className: clsx("textfield-input-dense", textAlign, textInputClass) }}
                                        InputLabelProps={{ shrink: true, style: { display: 'none !important' }, className: "textfield-input-label" }} // shrink: true, className: "textfield-input-label" 
                                        // InputLabelProps={{shrink: false}}
                                        fullWidth
                                        error={!!errors[field]}
                                        helperText={(errors[field] && errors[field].message) || helperText}
                                        size="small"
                                        disabled={disabled}
                                        multiline={multiline}
                                        rows={rows}
                                        autoComplete='new-password'


                                // {...rest}
                                />
                        )}
                        {...rest}
                />
        </>);
}

TextFieldInput.propTypes = {
        properties: PropTypes.shape({
                register: PropTypes.func,
                errors: PropTypes.object,
                setValue: PropTypes.func,
                clearError: PropTypes.func,
                schema: PropTypes.shape({
                        yupValidations: PropTypes.object,
                        customValidations: PropTypes.object,
                }),
        }).isRequired,
        textAlign: PropTypes.oneOf(["textfieldinput-right", "textfieldinput-left", "textfieldinput-center"]),
        label: PropTypes.string.isRequired,
        type: PropTypes.oneOf(["text", "number", "password"]),
        defaultValue: PropTypes.any,
        params: PropTypes.shape(),
        hintLabel: PropTypes.string,
        disabled: PropTypes.bool,
        readOnly: PropTypes.bool,
        inputClassName: PropTypes.string,
        multiline: PropTypes.bool,
        rows: PropTypes.number,
        noBorder: PropTypes.bool,
        standardvariant: PropTypes.bool,
};

TextFieldInput.defaultProps = {
        type: "text",
        textAlign: "textfieldinput-left",
        defaultValue: '',
        params: null,
        hintLabel: '',
        readOnly: false,
        multiline: false,
        rows: 1,
        inputClassName: '',
        noBorder: false,
        standardvariant: false,
        textInputClass: '',
        helperText: '',
        endAdornment: '',
};

export default TextFieldInput;